<template>

  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin' }">
    <template #title>
      <span>{{ translateTitleCase("admin.config.title") }}</span>
    </template>

    <template #default>
      <config-list-view></config-list-view>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import ConfigListView from "@/client/views/admin/config/List";

export default {
  name: "AdminConfigList",
  components: {
    ConfigListView,
  },
  layout: "adminDashboard",
  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady } = asyncOperations(props);

    return { asyncOps, asyncOpsReady };
  },
  meta: "admin.config.title",
  data: function () {
    return {};
  },
};
</script>
